import Hero from './sections/Hero';
import About from './sections/About';
import Skills from './sections/Skills';
import Projects from './sections/Projects';
import Contact from './sections/Contact';
import NavBar from './components/NavBar';
import BackgroundVideo from './components/BackgroundVideo';
import ArcadeVideo from './components/Arcade.mp4';
import React from 'react';

import { useEffect } from 'react';
import initReveal from './utils/reveal';

function App() {
  useEffect(() => initReveal(), []);

  return (
    <div className="min-h-screen text-white font-pressstart scanlines pt-14 md:pt-0">
      {/* Background video — using local `Arcade.mp4` (placed in `src/components`) */}
      <BackgroundVideo src={ArcadeVideo} poster="/images/arcade-poster.svg" mobilePoster="/images/arcade-poster-mobile.jpg" />

      <NavBar />

      {/* Semantic structure for SEO and accessibility */}
      <header>
        <Hero />
      </header>
      <main>
        <About />
        <Skills />
        <Projects />
      </main>
      <footer>
        <Contact />
      </footer>
    </div>
  );
}

export default App;
